export enum SPARE_PART_REQUEST_LINE_DETAILS_DOMAIN {
  REQUEST_LINE = 'requestLine',
  REQUEST = 'request',
}

export const SPARE_PART_REQUEST_LINE_DETAILS_DOMAIN_KEY = 'requestLineDetails';
